const routes = [
  {
    path: 'texting/settings',
    component: () => import(/* webpackChunkName: "TextingSettings" */ './views/TextingSettings.vue'),
    name: 'textingSettings',
    props: (route) => ({ ...route.query, ...route.params }),
  },
];

export default routes;
